import { Box, IconButton } from '@mui/material';
import { useRef } from 'react';
import { ThumbsDown } from '../../../../icons/thumbs-down';
import { ThumbsUp } from '../../../../icons/thumbs-up';
import { useAuth } from '../../../../hooks/useAuth';
import { PERMISSIONS } from '../../../../consts/permissions';
import { style } from './style';

type CandidateMatchesActionsProps = {
  onAcceptClick: () => void,
  onRejectClick: () => void,
}

export const CandidateMatchesActions = ({
  onAcceptClick,
  onRejectClick,
}:CandidateMatchesActionsProps): JSX.Element | null => {
  const rejectAnchorRef = useRef<HTMLButtonElement>(null);
  const { hasPermissions } = useAuth();

  const canPromoteMatchCandidate = hasPermissions([PERMISSIONS.MATCH_CANDIDATE_PROMOTE]);

  const canRejectMatchCandidate = hasPermissions([PERMISSIONS.MATCH_CANDIDATE_REJECT]);

  return (
    <Box style={ style.wrapper }>

      {canRejectMatchCandidate && (
        <>
          <IconButton
            ref={ rejectAnchorRef }
            onClick={ onRejectClick }
            sx={ style.declineIconButton.sx }
          >
            <ThumbsDown
              color="error"
              style={ style.icons.thumbsDown }
            />
          </IconButton>
        </>
      )}

      {canPromoteMatchCandidate && (
        <IconButton
          onClick={ onAcceptClick }
          sx={ style.promoteIconButton.sx }
        >
          <ThumbsUp
            color="success"
            style={ style.icons.thumbsUp }
          />
        </IconButton>
      )}

    </Box>
  );
};
